import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TPSubject } from 'app/shared/models/import';
import { Subject } from 'app/shared/models/subject';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';

@Component({
  selector: 'subject-match',
  templateUrl: './subject-match.component.html',
  styleUrls: ['./subject-match.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubjectMatchComponent implements OnInit {

  newSubject: Subject;
  existingSubject: Subject;
  matchingSubjects: Subject[];
  selectedSubject: Subject;
  subjectCount: number;
  preSelect: string;
  tpSubject: TPSubject;
  tpSubjectDetails: any[];

  constructor(
    public dialogRef: MatDialogRef<SubjectMatchComponent>,
    public dialog: MatDialog,
    private subjectTypeService: SubjectTypeService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data.subject) {
      this.newSubject = new Subject(this.data.subject);
      if ((!this.newSubject.subjectType) && this.newSubject.subjectTypeId) {
        this.subjectTypeService.getById(this.newSubject.subjectTypeId).subscribe((subjectType) => {
          this.newSubject.subjectType = subjectType;
        });
      }
    }

    if (this.data.tpSubject) {
      const s = this.data.tpSubject;
      const data = s.DataFields.map((field) => ({ Field: field.Label, Value: field.Value }));
      const subject = {
        Reference: s.Reference,
        Category: s.Category,
      };
      data.forEach((field) => {
        subject[field.Field] = field.Value;
      });
      this.tpSubject = this.data.tpSubject;
      this.tpSubjectDetails = [];
      Object.keys(subject).forEach((key) => {
        let value = subject[key];
        if (value.includes('|')) {
          const values = value.split('|');
          if (values.length > 1) {
            value = `${values[0]} (${values[1]})`;
          }
        }
        this.tpSubjectDetails.push({ key, value });
      });
    }

    if (this.data.existingSubject) {
      this.existingSubject = new Subject(this.data.existingSubject);
      this.selectedSubject = this.existingSubject;
      this.subjectCount = 1;
    }

    if (this.data.matchingSubjects && (this.data.matchingSubjects.length > 0)) {
      this.matchingSubjects = this.data.matchingSubjects.map((i) => new Subject(i));
      this.selectedSubject = this.matchingSubjects[0];
      this.subjectCount = this.matchingSubjects.length;
    }
  }

  add() {
    this.dialogRef.close({ subject: this.newSubject || this.tpSubject, existingSubject: undefined, data: this.data });
  }


  cancel() {
    this.dialogRef.close({ cancelled: true });
  }


  discard() {
    this.dialogRef.close({ subject: undefined, existingSubject: this.selectedSubject, data: this.data });
  }

  select(subjectLink) {
    if (subjectLink && subjectLink.linkedSubject) {
      this.selectedSubject = subjectLink.linkedSubject;
    }
  }
}
